import React, { HTMLAttributes, InputHTMLAttributes } from "react"
import { completeFormElementFactory, CompleteFormElementProps } from "./completeFormElementFactory"
import { SharedInputCssProps, StyledInputWithUnit } from "components/views/atoms/forms/StyledInputs"

type FormInputWithUnitProps = {
  unit?: string
} & HTMLAttributes<HTMLInputElement> &
  Partial<SharedInputCssProps> &
  InputHTMLAttributes<HTMLInputElement>

const FormInputWithUnit = React.forwardRef<HTMLInputElement, FormInputWithUnitProps>(
  ({ unit, valid = true, readOnly = false, type = "text", ...props }, ref) => {
    return (
      // @ts-ignore
      <div style={{ overflow: "hidden", whiteSpace: "nowrap" }}>
        <StyledInputWithUnit valid={valid} readOnly={readOnly} type={type} ref={ref} {...props} />
        <span style={{ color: "grey", position: "relative", left: "-28px" }}>{unit}</span>
      </div>
    )
  }
)

const CompleteFormInputWithUnit = completeFormElementFactory<
  HTMLInputElement,
  CompleteFormElementProps<HTMLInputElement> & FormInputWithUnitProps
>(FormInputWithUnit)

FormInputWithUnit.displayName = "FormInputWithUnit"

export { CompleteFormInputWithUnit, FormInputWithUnit }
